import { __rest } from 'tslib';
import React from 'react';
import { space } from 'styled-system';
import { styled } from '../../../libs/styled.es.js';

const StyledRow = styled.div(({ noGutters }) => `
  display: flex;
  flex-wrap: wrap;
  ${noGutters
    ? ''
    : `
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  `}
`, space);
const Row = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(StyledRow, Object.assign({}, props), children);
};

export { Row };
